import { render } from "./PathBar.vue?vue&type=template&id=12859162"
import script from "./PathBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PathBar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/PathBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12859162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12859162', __exports__)) {
    api.reload('12859162', __exports__)
  }
  
  module.hot.accept("./PathBar.vue?vue&type=template&id=12859162", () => {
    api.rerender('12859162', render)
  })

}


export default __exports__